module.exports = __webpack_public_path__ + "static/media/img-hero-greet.723765e5.png";